import Lightnings from './Lightnings';
export default Lightnings;
